class LidSelfInspectionModal {
  static formKey = "lid-self-inspection";
  static $modal = $("#assessment-modal");
  static initialData;
  static readOnly = false;

  static async show() {
    LidSelfInspectionModal.initialData = await PortalApiCalls.getLidSelfInspectionProject();
    LidSelfInspectionModal.#addBmpTitle(LidSelfInspectionModal.initialData);

    LidSelfInspectionModal.#render();
    LidSelfInspectionModal.#loadDomListeners();

    Analytics.sendScreenView("portal", LidSelfInspectionModal.formKey);
  }

  static async showPreview(initialData) {
    LidSelfInspectionModal.$modal.addClass("preview");
    LidSelfInspectionModal.initialData = initialData;
    LidSelfInspectionModal.readOnly = true;
    LidSelfInspectionModal.preview = true;

    LidSelfInspectionModal.#render();
    LidSelfInspectionModal.#loadDomListeners();
  }

  static #loadDomListeners() {
    LidSelfInspectionModal.$modal.on("click", ".save-button", LidSelfInspectionModal._warnAndSave);
    LidSelfInspectionModal.$modal.on("2N:FormInput", LidSelfInspectionModal.#checkEnableSaveButton);
    LidSelfInspectionModal.$modal.on("click", ".cancel-button", LidSelfInspectionModal.close);

    Form.initializeAndLoadListeners(LidSelfInspectionModal.$modal, LidSelfInspectionModal.formKey);
    Form.initializeDropzone(LidSelfInspectionModal.formKey, LidSelfInspectionModal.$modal, {
      readOnly: LidSelfInspectionModal.readOnly,
      directUpload: true,
    });
  }

  static #unloadDomListeners() {
    LidSelfInspectionModal.$modal.off("click", ".save-button", LidSelfInspectionModal._warnAndSave);
    LidSelfInspectionModal.$modal.off(
      "2N:FormInput",
      LidSelfInspectionModal.#checkEnableSaveButton,
    );
    LidSelfInspectionModal.$modal.off("click", ".cancel-button", LidSelfInspectionModal.close);
  }

  static #checkEnableSaveButton() {
    const canSaveLetter = LidSelfInspectionModal._hasAllRequiredFields();
    LidSelfInspectionModal.$modal.find(".save-button").toggleClass("disabled", !canSaveLetter);
  }

  static #render() {
    const html = nunjucks.render(LidSelfInspectionModal.#getNunjucksTemplate(), {
      initialData: LidSelfInspectionModal.initialData,
      readOnly: LidSelfInspectionModal.readOnly,
      preview: LidSelfInspectionModal.preview,
    });
    LidSelfInspectionModal.$modal.html(html);
    LidSelfInspectionModal.$modal.modal("show");
  }

  static #getNunjucksTemplate() {
    return "modals/portal/lidSelfInspection.njk";
  }

  static #getUpdateData(updateData) {
    updateData.bmpMaintenance = LidSelfInspectionModal.getBmpMaintenance(
      LidSelfInspectionModal.initialData.bmps,
      updateData.bmpMaintenance,
    );
    return {
      updates: updateData,
    };
  }

  static #addBmpTitle(initialData) {
    if (!initialData.bmps) {
      return;
    }

    for (const bmp of initialData.bmps) {
      bmp.cardText = LetterResponseModal.getCardTitle(bmp.name, bmp.typeDisplayName);
    }
  }

  static getBmpMaintenance(existingBmps, maintenanceUpdates = []) {
    const bmpMaintenance = [];

    for (let i = 0; i < existingBmps.length; i++) {
      bmpMaintenance.push({
        ...maintenanceUpdates[i],
        id: existingBmps[i].id,
      });
    }

    return bmpMaintenance;
  }

  static async _warnAndSave() {
    try {
      await MessageModal.showConfirmWarningModalAsPromise(
        `Are you ready to submit? Once you click “Submit” you will not be able to edit your response at a later time. Click “Submit” to officially submit your response, or click “Go Back” to return to the previous window and review your response.`,
        { returnMessage: "Go Back", okMessage: "Submit" },
      );
    } catch (e) {
      return;
    }

    try {
      await Form.getReadyToSavePromise(LidSelfInspectionModal.formKey);
      const updateData = LidSelfInspectionModal.#getUpdateData(
        Form.getDataFromForm(LidSelfInspectionModal.formKey, false),
      );
      await PortalApiCalls.saveNewLidSelfInspection(updateData);
      PortalController.goWithSecret("portal-lid-self-inspection-confirmation");
    } catch (e) {
      return UploadValidator.reportError(e);
    }
  }

  static close() {
    Form.clearForm(LidSelfInspectionModal.formKey);
    LidSelfInspectionModal.#unloadDomListeners();
    LidSelfInspectionModal.$modal.modal("hide");
  }

  static _hasAllRequiredFields() {
    const data = Form.getDataFromForm(LidSelfInspectionModal.formKey, false);

    return (
      LidSelfInspectionModal._allFieldsFilled(data, ["signature", "name"]) &&
      LidSelfInspectionModal._allBmpsHaveNotes(data)
    );
  }

  static _allFieldsFilled(data, requiredFields) {
    let requiredFilled = 0;

    for (const key in data) {
      if (requiredFields.includes(key) && !!data[key]) {
        requiredFilled++;
      }
    }

    return requiredFilled === requiredFields.length;
  }

  static _allBmpsHaveNotes(data) {
    const bmps = LidSelfInspectionModal.initialData.bmps;

    for (let i = 0; i < bmps.length; i++) {
      if (!data.bmpMaintenance?.[i]?.notes) {
        return false;
      }
    }

    return true;
  }
}

module.exports = LidSelfInspectionModal;

const Analytics = require("../../general/analytics");
const PortalApiCalls = require("../portalApiCalls");
const Form = require("../../general/form");
const MessageModal = require("../../modals/messageModal");
const PortalController = require("../portalController");
const LetterResponseModal = require("../../lid/letterResponseModal");
const UploadValidator = require("../../general/uploadValidator");
